import { StrictMode } from "react";
import { ErrorBoundary, ToastProvider } from "@suite/ui";
import { App, STORAGE_KEY } from "./App.tsx";

/** The full client tree. Shared by main.tsx and prerender.tsx so the two match. */
export function Root() {
  return (
    <StrictMode>
      <ErrorBoundary storageKey={STORAGE_KEY}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
